export const ButtonText = {
  ALLES: 'alles',
  MEER: 'meer',
  TOONMEER: 'toon meer',
  TOONALLES: 'toon alles',
};

export const ShowMoreButtonTypes = {
  LINK: 'link',
  TEXT_LINK: 'text-link',
  BUTTON: 'button',
  CTA: 'cta',
};
